"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormContainer = void 0;
exports.mapDispatchToProps = mapDispatchToProps;
exports.mapStateToProps = mapStateToProps;
var _reactRedux = require("react-redux");
var _selectors = require("./selectors");
var _registration = require("../../../../actions/registration");
var _view = require("../../../../actions/view");
var _events = require("../../../../actions/events");
var _FormContainer = require("./FormContainer");
var _source = require("../../../../selectors/source");
function mapStateToProps(state) {
  return {
    sendSmsStatus: (0, _selectors.sendSmsStatusSelector)(state),
    isSubmitting: (0, _selectors.isConfirmPhoneFormSubmittingSelector)(state),
    phone: (0, _selectors.viewDataPhoneSelector)(state),
    email: (0, _selectors.viewDataEmailSelector)(state),
    hasCodeError: (0, _selectors.hasCodeErrorSelector)(state),
    codeError: (0, _selectors.codeErrorSelector)(state),
    source: (0, _source.sourceSelector)(state)
  };
}
function mapDispatchToProps(dispatch) {
  return {
    sendSms(parameters) {
      dispatch((0, _registration.sendSms)(parameters));
    },
    confirmPhone(parameters) {
      dispatch((0, _registration.confirmPhone)(parameters));
    },
    changeView(view, data) {
      dispatch((0, _view.changeView)(view, data));
    },
    emit(type, event) {
      dispatch((0, _events.emit)(type, event));
    }
  };
}
const FormContainer = exports.FormContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_FormContainer.FormContainer);